import { AsyncLocalStorage } from "async_hooks";

import type { Request, Response, NextFunction } from "express";

const store = new AsyncLocalStorage();

export const middleware = (projectId: string) => (req: Request, _res: Response, next: NextFunction) => {
  const correlationHeader = req.header("X-Cloud-Trace-Context");

  if (correlationHeader) {
    const [ traceId ] = correlationHeader.split("/");
    store.run({ "logging.googleapis.com/trace": `projects/${projectId}/traces/${traceId}` }, () => next());
  } else {
    next();
  }
};

export const getTraceObject = (): object => {
  return store.getStore() || {} as object
};
